export const ru = {
    'many-linked-camps-count': '{count} кампаний',
    'one-linked-camps': '{count} кампания',
    'some-linked-camps': '{count} кампании',
    'zero-linked-camps': 'нет привязанных кампаний'
};
